export const shapeName = 'TSAbortAgentMessageResponse';
export const schema = {
    type: 'object',
    properties: {
        aborted: {
            type: 'object',
            properties: {
                messageId: { type: 'string', description: 'The ID of the aborted deferred message' }
            },
            required: ['messageId'],
            additionalProperties: false
        }
    },
    required: [],
    additionalProperties: false
};
export const shapeSchema = {
    ...schema
};
